
import {of as observableOf,  Observable } from 'rxjs';

import {switchMap, withLatestFrom} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MemberApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import * as actions from '../actions/index';
import * as selectors from '../reducers/index';

@Injectable()
export class ProfileEffects {
  @Effect()
  requestProfile = this.actions$
    .ofType(actions.REQUEST_UPDATED_PROFILE).pipe(
    withLatestFrom(this.store.select(selectors.auth.getAuth)),
    switchMap(([action, auth]) =>
      this.api
        .findById(auth.userId)
        .map(result => new actions.ResponseSuccessUpdatedProfileAction(result))
        .catch(err => observableOf(new actions.ResponseFailUpdatedProfileAction(err.message)))
    ),);

  @Effect()
  saveProfile = this.actions$
    .ofType(actions.REQUEST_SAVE_PROFILE).pipe(
    withLatestFrom(this.store.select(selectors.auth.getAuth)),
    switchMap(([action, auth]) =>
      this.api
        .updateDetails(auth.userId, action.payload)
        .map(result => new actions.ResponseSuccessSaveProfileAction(result))
        .catch(err => observableOf(new actions.ResponseFailSaveProfileAction(err.message)))
    ),);

  constructor(
    public store: Store<any>,
    public actions$: Actions<actions.CAAction>,
    public api: MemberApi
  ) {}
}
